<template>
  <a-result status="404" title="功能完善中" sub-title="抱歉，搜索功能正在开发中，敬请期待">
    <template #extra>
      <a-button v-on:click="onClickFeedback" type="link">
        反馈
      </a-button>
      <a-button v-on:click="onClickBack" type="primary">
        返回主页
      </a-button>
    </template>
  </a-result>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    onClickBack() {
      this.$router.push({ path: '/' });
    },
    onClickFeedback() {
      this.$router.push({ path: '/feedback' });
    }
  }
};
</script>
